import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
  MenuItem,
  Chip
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

const ProcessInquiry = () => {
  const [jobId, setJobId] = useState("");
  const [jobName, setJobName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("");

  // Dummy Data (Replace with API call later)
  const jobData = [
    {
      id: 1,
      jobId: "JOB_1001",
      jobName: "Import Collections",
      startDate: "2026-02-20 10:00",
      endDate: "2026-02-20 10:10"
    },
    {
      id: 2,
      jobId: "JOB_1002",
      jobName: "Reconciliation",
      startDate: "2026-02-21 11:00",
      endDate: "2026-02-21 11:20"
    }
  ];

  const columns = [
    { field: "jobId", headerName: "Job ID", flex: 1 },
    { field: "jobName", headerName: "Job Name", flex: 1 },
    { field: "startDate", headerName: "Start Date", flex: 1 },
    { field: "endDate", headerName: "End Date", flex: 1 },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => getStatusChip(params.value)
    }
  ];

  const getStatusChip = (status) => {
    const colors = {
      RUNNING: "primary",
      PENDING: "info",
      COMPLETED: "success",
      FAILED: "error"
    };
    return <Chip label={status} color={colors[status]} size="small" />;
  };

  const handleSearch = () => {
    const filtered = jobData.filter((job) => {
      return (
        (jobId === "" || job.jobId.toLowerCase().includes(jobId.toLowerCase())) &&
        (jobName === "" || job.jobName.toLowerCase().includes(jobName.toLowerCase())) &&
        (startDate === "" || job.startDate >= startDate) &&
        (endDate === "" || job.endDate <= endDate)
      );
    });

    setRows(filtered);
  };

  const handleReset = () => {
    setJobId("");
    setJobName("");
    setStartDate("");
    setEndDate("");
    setRows([]);
  };

  return (
    <Box p={3}>
      <Typography variant="h5" mb={3}>
        Process Inquiry
      </Typography>

      {/* -------------------- SEARCH SECTION -------------------- */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">

          <Grid item xs={2}>
            <TextField
              fullWidth
              label="Job ID"
              value={jobId}
              onChange={(e) => setJobId(e.target.value)}
            />
          </Grid>

          <Grid item xs={2}>
            <TextField
              fullWidth
              label="Job Name"
              value={jobName}
              onChange={(e) => setJobName(e.target.value)}
            />
          </Grid>

          <Grid item xs={1.5}>
            <TextField
              fullWidth
              type="date"
              label="Start Date"
              InputLabelProps={{ shrink: true }}
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </Grid>

          <Grid item xs={1.5}>
            <TextField
              fullWidth
              type="date"
              label="End Date"
              InputLabelProps={{ shrink: true }}
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </Grid>

          <Grid item xs={2}>
            <TextField
              select
              fullWidth
              size="small"
              label="Status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="RUNNING">RUNNING</MenuItem>
              <MenuItem value="PENDING">PENDING</MenuItem>
              <MenuItem value="COMPLETED">COMPLETED</MenuItem>
              <MenuItem value="FAILED">FAILED</MenuItem>
            </TextField>
          </Grid>

          {/* ✅ Buttons Section */}
          <Grid item xs>
            <Grid container justifyContent="flex-end" spacing={2}>
              <Grid item>
                <Button
                  variant="outlined"
                  startIcon={<SearchIcon />}
                  onClick={handleSearch}
                  sx={{
                    backgroundColor: "#1976d2",
                    "&:hover": { backgroundColor: "#1565c0" }
                  }}
                >
                  Search
                </Button>
              </Grid>

              <Grid item>
                <Button
                  variant="outlined"
                  startIcon={<RestartAltIcon />}
                  onClick={handleReset}
                  sx={{
                    backgroundColor: "#1976d2",
                    "&:hover": { backgroundColor: "#1565c0" }
                  }}
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </Paper>

      {/* -------------------- RESULT GRID -------------------- */}
      <Paper sx={{ height: 400, p: 2 }}>
        <Typography variant="h6" mb={2}>
          Search Results
        </Typography>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5, 10]}
        />
      </Paper>
    </Box>
  );
};

export default ProcessInquiry;